import { formatAnyDate } from '@/utils/helpers/dates';
import { ConnectResult } from '@/connect';
import { ApiError } from '@/utils/errors';

export function saveFile(
  content: Uint8Array,
  filename: string,
  ext: 'xlsx' | 'csv' = 'xlsx'
): void {
  const nowStr = formatAnyDate(new Date(), 'yyyyMMdd-HHmmss');
  const name = `${filename}-${nowStr}.${ext}`;

  const blob = new Blob([content], {
    type:
      ext === 'xlsx'
        ? 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        : 'text/csv',
  });
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = name;
  link.click();
  URL.revokeObjectURL(link.href);
}

export async function saveFileFromConnectEndpoint(
  response: Promise<ConnectResult<{ content: Uint8Array }>>,
  filename: string,
  ext: 'xlsx' | 'csv' = 'xlsx'
): Promise<void> {
  const res = await response;
  if (!res.success) {
    throw new ApiError(res.error, res.details);
  }

  return saveFile(res.data.content, filename, ext);
}
